import { Box, Text } from '@factorialco/deprecated-design-system'
import { F0Icon } from '@factorialco/f0-react'
import { Tooltip, TwoColumnsList } from '@factorialco/f0-react/dist/experimental'
import { InfoCircleLine } from '@factorialco/f0-react/icons/app'
import { format } from 'date-fns'

import { minutesToText } from 'modules/core/lib/duration'
import i18n from 'modules/core/lib/i18n'

import EmptyState from './EmptyState'
import { DailyTimeCategory } from './utils'

type Props = {
  dailyTimeCategories: DailyTimeCategory[]
}

const TimeCategoriesBreakdown = ({ dailyTimeCategories }: Props) => {
  const emptyState = dailyTimeCategories.length === 0

  if (emptyState)
    return (
      <EmptyState
        header={i18n.t(
          'clock_in.sidepanel.compensation_time_categories_breakdown.empty_state_header'
        )}
        body={i18n.t('clock_in.sidepanel.compensation_time_categories_breakdown.empty_state_body')}
      />
    )

  return (
    <>
      <Box flexDirection="row" gap="s8" alignItems="center">
        <Text size="300" color="black" weight="bold">
          {i18n.t('clock_in.sidepanel.compensation_time_categories_breakdown.header')}
        </Text>
        <Tooltip
          label={i18n.t('clock_in.sidepanel.compensation_time_categories_breakdown.tooltip_label')}
          description={i18n.t(
            'clock_in.sidepanel.compensation_time_categories_breakdown.tooltip_description'
          )}
        >
          <F0Icon icon={InfoCircleLine} size="sm" color="secondary" />
        </Tooltip>
      </Box>

      {dailyTimeCategories.map((dailyTimeCategory) => (
        <TwoColumnsList
          key={dailyTimeCategory.date.toString()}
          title={format(dailyTimeCategory.date, 'dd MMMM')}
          list={dailyTimeCategory.timeCategories.map((timeCategory) => ({
            title: timeCategory.name,
            info: minutesToText(timeCategory.minutes),
          }))}
        />
      ))}
    </>
  )
}

export default TimeCategoriesBreakdown
